export const INITIALIZE_OUR_APPS_PAGE = 'initialize-our-apps-page';
const initializeOurAppsPage = () => ({ type: INITIALIZE_OUR_APPS_PAGE });
export default initializeOurAppsPage;
